/* eslint-disable import/no-anonymous-default-export */
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import TourOutlinedIcon from "@mui/icons-material/TourOutlined";
import DirectionsBusOutlinedIcon from "@mui/icons-material/DirectionsBusOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import AddIcon from "@mui/icons-material/Add";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ListAltIcon from "@mui/icons-material/ListAlt";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";

export default [
  // {
  //   name: "دربستی",
  //   path: "/hiring-list",
  //   icon: TourOutlinedIcon,
  // },
  {
    name: "دربستی‌",
    icon: TourOutlinedIcon,
    children: [
      {
        name: "ثبت دربستی",
        path: "/hiring",
        icon: AddIcon,
      },
      {
        name: "لیست دربستی‌ها",
        path: "/hiring-list",
        icon: ListAltIcon,
      },
      {
        name: "ثبت تقاضای دربستی",
        path: "/hiring-request",
        icon: AddIcon,
      },
      {
        name: "لیست تقاضای دربستی",
        path: "/hiring-request-list",
        icon: ListAltIcon,
      },
      {
        name: "دربستی برنامه‌ریزی شده",
        path: "/scheduled-hiring",
        icon: AddIcon,
      },
      {
        name: "لیست دربستی برنامه‌ریزی شده",
        path: "/scheduled-hiring-list",
        icon: ListAltIcon,
      },
      {
        name: "دربستی‌های آزاد",
        path: "/hiring-accept",
        icon: FlagOutlinedIcon,
      },
    ],
  },

  {
    name: "سرویس",
    icon: RouteOutlinedIcon,

    children: [
      {
        name: "پروژه",
        path: "/project",
        icon: HomeWorkOutlinedIcon,
      },
      {
        name: "سرویس ها",
        path: "/services",
        icon: RouteOutlinedIcon,
      },
      {
        name: "ثبت سرویس",
        path: "/service",
        icon: AddIcon,
      },
    ],
  },
  {
    name: "مسافران",
    path: "/passenger/list",
    icon: PeopleAltOutlinedIcon,
  },
  {
    name: "ناوگان",
    path: "/driver/list",
    icon: DirectionsBusOutlinedIcon,
  },

  // {
  //   name: "اپراتورها",
  //   path: "/operator",
  //   icon: ManageAccountsOutlinedIcon,
  // },
];
